export enum LayoutEnv {
  Web = "web",
  Tablet = "tablet",
  Mobile = "mobile",
}

const MOBILE_MAX_WIDTH = 767;
const TABLET_MAX_WIDTH = 1100;

export const getLayoutEnv = (): LayoutEnv => {
  const width = window.innerWidth;

  if (width <= MOBILE_MAX_WIDTH) {
    return LayoutEnv.Mobile;
  } else if (width > MOBILE_MAX_WIDTH && width <= TABLET_MAX_WIDTH) {
    return LayoutEnv.Tablet;
  } else {
    return LayoutEnv.Web;
  }
};

export const isMobile = () => getLayoutEnv() === LayoutEnv.Mobile;
export const isTablet = () => getLayoutEnv() === LayoutEnv.Tablet;
export const isWeb = () => getLayoutEnv() === LayoutEnv.Web;
